export const Header = () => {
  return (
    <header className="text-nobel/50 mb-3.5 grid grid-cols-[0.5fr_1fr_1fr_1fr] px-3.5 leading-[145%] font-normal">
      <div>Rank</div>
      <div>Address</div>
      <div>Points</div>
      <div className="justify-self-end">% of Points Supply</div>
    </header>
  );
};
